<div>
	<pannel [title]="'D&eacute;finition de l&rsquo;op&eacute;ration'">
		<!-- N° PDP -->
		<div class="form-group col-sm-12">
			<div class="col-sm-3">
				<label for="autre" class="control-label">N&deg; PDP *:</label>
			</div>
			<div class="col-sm-5">
				<input id="numeroPdp" name="numeroPdp" [disabled]="planPreventionModel.etat !== etatPdp.BROUILLON && planPreventionModel.etat !== etatPdp.A_FAIRE_SIGNER"
					   [ngClass]="'form-control' + (mandatoryField ? ' mandatory-field' : '')"
					   placeholder="N&deg; PDP" [maxLength]="128" [(ngModel)]="numeroPdp" (change)="onNumeroPdpChange($event)" />
			</div>
		</div>
		<!-- Parc -->
		<div class="form-group col-sm-12">
			<div class="col-sm-3">
				<label for="choixParc" class="control-label">Parc *: </label>
			</div>
			<div class="col-sm-5">
				<parc-by-groupement-multi-selector 
						[id]="'choixParcs'"
						[disabled]="fieldsDisabled || planPreventionModel.mode === 'update'"
						[fieldClass]="'pdp-parc-field-selector' + (mandatoryField ? ' highlightable' : '')"
						[antenneId]="antenneId ? antenneId : null"
						[(selectedParcIds)]="planPreventionModel.parcIds"
						(selectedParcsChange)="onParcSelected($event)" >
				</parc-by-groupement-multi-selector>
				
			</div>
		</div>
		<div class="form-group col-sm-12" *ngIf="planPreventionModel.parcIds.length" >
			<div class="col-sm-3">
				<label for="choixOuvrage" class="control-label">Ouvrage(s) *: </label>
			</div>
			<div class="form-group col-sm-5 no-padding-right" *ngIf="planPreventionModel.mode !== 'update'">
				<ouvrage-by-groupement-multi-selector
						*ngIf="groupementParc && !selectedParc"
						[id]="'choixOuvrage'"
						[disabled]="fieldsDisabled || planPreventionModel.mode === 'update'"
						[labelClass]="'col-md-12 pdp-ouvrage-selector'"
						[fieldClass]="ouvrageSelectorClass"
						[selectedParcIds]="planPreventionModel.parcIds"
						[groupement]="groupementParc"
						[(selectedOuvrageIds)]="ouvrageIds"
						(selectedOuvragesChange)="onSelectedOuvragesChange($event, true)" >
				</ouvrage-by-groupement-multi-selector>
				<ouvrage-by-sous-parc-multi-selector
						*ngIf="!groupementParc && selectedParc"
						[id]="'choixOuvrage'"
						[disabled]="fieldsDisabled || planPreventionModel.mode === 'update'"
						[labelClass]="'col-md-12 pdp-ouvrage-selector'"
						[fieldClass]="ouvrageSelectorClass"
						[parc]="selectedParc"
						[(selectedOuvrageIds)]="ouvrageIds"
						(selectedOuvragesChange)="onSelectedOuvragesChange($event, true)" >
				</ouvrage-by-sous-parc-multi-selector>
			</div>
			<div class="col-sm-5" *ngIf="planPreventionModel.mode === 'update'">
				<input id="ouvrageNames" name="ouvrageNames" [disabled]="true" class="form-control" [(ngModel)]="ouvrageNames" />
			</div>
		</div>
		<div class="form-group col-sm-12">
			<div class="col-sm-3"></div>
			<div class="col-sm-5">
				<span style="color: red; font-weight: bold;">Assurez-vous de s&eacute;lectionner tous les ouvrages concern&eacute;s par les interventions du plan de pr&eacute;vention. Pour un pdp g&eacute;n&eacute;ral, s&eacute;lectionnez tous les ouvrages</span>
			</div>
		</div>
		<!-- Autre -->
		<div class="form-group col-sm-12">
			<div class="col-sm-3">
				<label for="autre" class="control-label">Autre&nbsp;:</label>
			</div>
			<div class="col-sm-5">
				<input id="autre" name="autre" class="form-control"  [(ngModel)]="autre" (change)="onAutreChange($event)" [maxLength]="128" 
					[disabled]="planPreventionModel.etat !== etatPdp.BROUILLON && planPreventionModel.etat !== etatPdp.A_FAIRE_SIGNER" />
			</div>
		</div>
		<!-- Type -->
		<div class="form-group col-sm-12">
			<div class="col-sm-3">
				<label for="autre" class="control-label">Type&nbsp;:</label>
			</div>
			<div class="col-sm-5">
				<mat-radio-group [ngModelOptions]="{standalone: true}" 
					[disabled]="(planPreventionModel.etat !== etatPdp.BROUILLON && planPreventionModel.etat !== etatPdp.A_FAIRE_SIGNER) || planPreventionModel.mode === 'duplicate'" 
					[(ngModel)]="typePdp" (change)="typePdpChange($event)" color="primary">
					<mat-radio-button *ngFor="let type of listeTypePdp" [value]="type" [checked] = "type === typePdp" >
						{{type}}&nbsp;
					</mat-radio-button>
				</mat-radio-group>
			</div>
		</div>

		<!-- Date de demarrage -->
		<div class="form-group col-sm-12">
			<div class="col-sm-3">
				<label for="dateDebut" class="control-label">Date de d&eacute;but&nbsp;*:</label>
			</div>
			<div [ngClass]="'col-sm-5' + (mandatoryField ? ' highlightable' : '')">
				<date-input
						[id]="'dateDebut'"
						[(localDate)]="dateDebut"
						[disabled]="planPreventionModel.mode === 'update' && shouldDisableMajDateDebut()"
						(localDateChange)="onDateDebutChange($event)"
						aria-placeholder="Saisissez la date de d&eacute;but"
				>
				</date-input>
			</div>
		</div>

		<!-- Date de fin -->
		<div class="form-group col-sm-12">
			<div class="col-sm-3">
				<label for="dateFin" class="control-label">Date de fin&nbsp;*:</label>
			</div>
			<div [ngClass]="'col-sm-5' + (mandatoryField ? ' highlightable' : '')">
				<date-input
						[id]="'dateFin'"
						[(localDate)]="dateFin"
						aria-placeholder="Saisissez la date de fin"
						[disabled]="shouldDisableMajDateFin()"
						(localDateChange)="onDateFinChange($event)"
				>
				</date-input>
			</div>
		</div>

		<!-- Durée -->
		<div class="form-group col-sm-12">
			<div class="col-sm-3">
				<label for="duree" class="control-label">Durée&nbsp;{{this.typeDuree}}&nbsp;:</label>
			</div>
			<div class="col-sm-5">
				<input type="number" class="form-control" name="duree" min="1" placeholder="1" 
					[(ngModel)]="duree" [disabled]="planPreventionModel.mode === 'update' || dureeDisabled" (change)="calculateDateFin()" />
				<div class="alert alert-warning" *ngIf="duree > 364" >La p&eacute;riode maximale autoris&eacute;e pour un plan de pr&eacute;vention sp&eacute;cifique est de 364 jours</div>
				<div class="alert alert-warning" *ngIf="duree < 1" >La date de début doit être antérieure à la date de fin</div>
			</div>
		</div>

		<!-- Nombre d'intervenants -->
		<div class="form-group col-sm-12">
			<div class="col-sm-3">
				<label for="nombreintervenants" class="control-label">Nombre pr&eacute;visible d&rsquo;intervenants&nbsp;:</label>
			</div>
			<div class="col-sm-5">
				<input id="nombreintervenants" name="nombreintervenants" min="0" type="number"
					   class="form-control" (change)="onNbIntervenantsChange($event)"
					   [(ngModel)]="nombreIntervenants"
				/>
			</div>
		</div>
		
		<!-- Description -->
		<div class="form-group col-sm-12">
			<div class="col-sm-3">
				<label for="description" class="control-label">Description:</label>
			</div>
			<div class="col-sm-5">
				<textarea name="description" cols="50" rows="8" placeholder="Description" [maxLength]="1500" [disabled]="planPreventionModel.mode !== 'duplicate' && ((planPreventionModel.etat !== etatPdp.A_FAIRE_SIGNER && planPreventionModel.etat !== etatPdp.BROUILLON) || planPreventionModel.obsolete)"
					[(ngModel)]="planPreventionModel.description" class="form-control" (change)="onDescriptionChange($event)">
				</textarea>
			</div>
		</div>

	</pannel>
</div>